<div class="table-container">
    <p-table [value]="data" [scrollable]="true" [loading]="loading()" [rows]="rows()" [totalRecords]="totalRecords()"
        [lazy]="true" class="p-table-fixed" dataKey="Id">

        <ng-template #header>

            <tr>
                @if (isAdmin) {
                    <th style="width: 4rem">
                        <p-checkbox [binary]="true" [(ngModel)]="isAllSelected" (onChange)="onToggleAll($event.checked)" [disabled]="isHeaderDisabled()" [class.p-checkbox-indeterminate]="isIndeterminate" />
                    </th>
                }

                <th class="cursor-pointer w-[8rem] " pFrozenColumn alignFrozen="left">
                    <app-sort-header columnName="Alcance" columnKey="Category" [sortBy]="sortBy()!"
                        [sortOrder]="sortOrder()!" (toggleSort)="handleToggleSort('Category')" />
                </th>
                <th class="cursor-pointer w-[8rem]">
                    <app-sort-header columnName="Categoría" columnKey="Category" [sortBy]="sortBy()!"
                        [sortOrder]="sortOrder()!" (toggleSort)="handleToggleSort('Category')" />
                </th>
                <!-- <th class="cursor-pointer w-[12rem]">
                    <app-sort-header columnName="Fuente de emisión" columnKey="Source" [sortBy]="sortBy()!"
                        [sortOrder]="sortOrder()!" (toggleSort)="handleToggleSort('Source')" />
                </th> -->
                <th class="cursor-pointer w-[10rem]">
                    <app-sort-header columnName="Fuente de emisión" columnKey="Variation" [sortBy]="sortBy()!"
                        [sortOrder]="sortOrder()!" (toggleSort)="handleToggleSort('Variation')" />
                </th>
                <th class="cursor-pointer w-[10rem]">
                    <app-sort-header columnName="Referencia de actividad" columnKey="Reference" [sortBy]="sortBy()!"
                        [sortOrder]="sortOrder()!" (toggleSort)="handleToggleSort('Reference')" />
                </th>
                <!-- <th class="cursor-pointer w-[8rem]">
                    <app-sort-header columnName="Tipo" columnKey="Type" [sortBy]="sortBy()!" [sortOrder]="sortOrder()!"
                        (toggleSort)="handleToggleSort('Type')" />
                </th> -->
                <!-- <th class="cursor-pointer w-[8rem]">
                    <app-sort-header columnName="Metodología" columnKey="Method" [sortBy]="sortBy()!"
                        [sortOrder]="sortOrder()!" (toggleSort)="handleToggleSort('Method')" />
                </th> -->
            </tr>
        </ng-template>
        <ng-template #body let-source>
            <tr>
                @if (isAdmin) {
                    <td>
                        <p-checkbox [binary]="true" [ngModel]="source.IsAssigned" (onChange)="onRowToggle(source, $event.checked)" [disabled]="isRowDisabled(source)" />
                    </td>
                }

                <td pFrozenColumn alignFrozen="left">{{ source.Scope}}</td>
                <td>{{source.Category}}</td>
                <!-- <td>{{ getFactorName(source.Source, "sources") }}</td> -->
                <td>{{ getFactorName(source.Variation, "variations") }}</td>
                <td>{{ getFactorName(source.Reference, "references") }}</td>
                <!-- <td>{{ getFactorName(source.Type, "types") }}</td>
                <td>{{ getFactorName(source.Method, "method") }}</td> -->

            </tr>
        </ng-template>
        <ng-template #emptymessage>
            <tr>
                <td [attr.colspan]="isAdmin ? 5 : 4">No se encontraron fuentes de emisión</td>
            </tr>
        </ng-template>
    </p-table>

    <app-paginator [first]="first()" [rows]="rows()" [totalRecords]="totalRecords()"
        (pageChange)="pageChange.emit($event)" />

</div>